import {connect} from '@modifi/redux'
import {compose} from 'ramda'
import {withTranslation} from '@modifi/plugin-i18n'
import {routerActions} from '@modifi/router'
import {selectUser} from '@modifi/plugin-user/register'
import {aFetchInvoices, selectInvoicesByProductType, selectInvoicesAreLoading} from '../../store'

import selectProductTypes from '../../../../utils/selectProductTypes'
import Billing from './Billing'

const mapStateToProps = (state, {activeTab}) => ({
  productTypes: selectProductTypes(selectUser(state)),
  invoiceList: selectInvoicesByProductType(state)(activeTab),
  isActiveTabLoading: selectInvoicesAreLoading(state)(activeTab),
})

const mapDispatchToProps = {
  switchTab: routerActions.replace,
  fetchInvoices: aFetchInvoices,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTranslation('treseus')
)(Billing)
